import React from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Button} from "primereact/button";
import {Badge} from "primereact/badge";

const CandidateNoteListComponent = (props) => {

  const history = useHistory();
  const {id} = useParams();
  const notes = props.notes || [];

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        {localStorage.getItem('roles').toString().includes('role_') &&
          <Button icon="pi pi-pencil" className="p-button-warning p-button-sm p-mr-2"
                  tooltip={props.t('edit')} tooltipOptions={{position: 'left'}}
                  onClick={() => {
                    history.push(`/recruitment/candidate/read/${id}?update=candidate-note&candidateNoteId=${rowData.id}&candidateId=${id}`)
                  }}/>
        }
      </React.Fragment>
    );
  }

  const renderCard = (rowData) => (
    <div key={rowData.id} className="p-card p-shadow-2 p-mb-3" style={{overflow: 'hidden'}}>
      <div className="p-p-3 p-d-flex p-jc-between p-ai-start p-flex-wrap" style={{gap: '1rem'}}>
        <div className="p-d-flex p-flex-column" style={{gap: '0.85rem', flex: '1 1 240px'}}>
          <div className="p-d-flex p-ai-center p-flex-wrap" style={{gap: '0.5rem'}}>
            <span style={{display: 'inline-block'}}>
              <Badge value={props.t('comment')} severity="info" rounded />
            </span>
          </div>
          <div style={{whiteSpace: 'pre-wrap', lineHeight: 1.6}}>{rowData?.note || props.t('noCommentProvided')}</div>
          <div className="p-text-secondary">
              {props.t('created')}: {rowData?.created_at ? window.App.formatDateValue(rowData.created_at) : <span style={{color: '#a8a8a8'}}>? </span>}
          </div>
          <div className="p-text-secondary">
            {props.t('updated')}: {rowData?.updated_at ? window.App.formatDateValue(rowData.updated_at) : <span style={{color: '#a8a8a8'}}>? </span>}
          </div>
        </div>
        <div className="p-d-flex p-ai-start">
          {actionBodyTemplate(rowData)}
        </div>
      </div>
    </div>
  )

  return (
    <>
      <div className="p-d-flex p-flex-column">
        {notes.length > 0 ? notes.map(renderCard) : (
          <div className="p-p-3 p-text-secondary p-text-center p-border-1" style={{borderStyle: 'dashed', borderRadius: '12px'}}>
            {props.t('noResults')}
          </div>
        )}
      </div>
    </>
  )
}
export default withTranslation('common')(CandidateNoteListComponent);
